module.exports = __webpack_public_path__ + "media/site_templates/www.doorinstallation.company/images/testimonials-c80b06703f5e1a025714b32a6c0f279c.jpg";